export default {
  title: 'Ofertas Exclusivas',
  header: {
    back: 'Voltar',
    title: 'Recompensas',
  },
  info: {
    title: 'Tem {{points}} pontos.',
    description: 'Gaste {{amount}} para obter 5 pontos! Adicione artigos ao carrinho gratuitamente com os seus pontos.',
  },
  rewards: {
    data: [
      {
        title: 'Ganhe Pontos em Cada Encomenda',
        description: 'Por cada {{amount}} que gasta, acumula 5 pontos na sua conta.',
      },
      {
        title: 'Ganhe Pontos em Cada Encomenda',
        description:
          'Troque os seus pontos por brindes gratuitos! Comece a usar pontos a partir de 350 pontos, equivalente a gastar {{amount}}.',
      },
      {
        title: 'Ganhe Pontos em Cada Encomenda',
        description:
          'Descubra ofertas exclusivas, promoções e descontos. Consulte as promoções exclusivas para membros na app.',
      },
    ],
  },
};
